import DynamicTable from '../Table';

export default function CostAllocationMain(props: {
	handlePayPeriodId: (value: string) => void;
	searchValue: string;
	setSearchValue: (v: string) => void;
	filterValue: any;
	setFilterValue: (v: any) => void;
	sortBy: string | null;
	setSortBy: (v: string | null) => void;
	sortType: string | null;
	setSortType: (v: string | null) => void;
	isCostAllocation?: string;
	onScreenChange?: () => void;
	isExpanded?: boolean;
}) {
	const {
		handlePayPeriodId,
		searchValue,
		setSearchValue,
		filterValue,
		setFilterValue,
		sortBy,
		setSortBy,
		sortType,
		setSortType,
		isCostAllocation,
		onScreenChange,
		isExpanded,
	} = props;
	return (
		<>
			<DynamicTable
				handlePayPeriodId={handlePayPeriodId}
				searchValue={searchValue}
				setSearchValue={setSearchValue}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				sortBy={sortBy}
				setSortBy={setSortBy}
				sortType={sortType}
				setSortType={setSortType}
				isCostAllocation={isCostAllocation}
				onScreenChange={onScreenChange}
				isExpanded={isExpanded}
			/>
		</>
	);
}